<!-- <template>
  <nuttrema-layout-content>

    <nuttrema-layout-content-header slot="header">
      <product-info-small-card
         slot="left"
        :details="ProductDetails.data">
      </product-info-small-card>
      <nuttrema-group-and-sort
        slot="center"
        class="is-centered">
        <h4 v-if="labels.section" slot="label" class="no-padding is-uppercase is-gray">
          {{ $t(labels.section) }}
        </h4>
        <h4 v-if="labels.title" slot="content" class="content--title">
          {{ $t(labels.title) }}
        </h4>
      </nuttrema-group-and-sort>
      <div slot="right" class="level-item">
        <h4 style="margin-right: 0.5em;">{{ $t('label.edit') }}</h4>
        <el-switch v-model="edit"></el-switch>
      </div>
    </nuttrema-layout-content-header>

    <nuttrema-loader
      v-if="isLoading" slot="central">
    </nuttrema-loader>

    <nuttrema-empty-result
      v-else-if="isEmpty"
      slot="central"
      icon="far fa-battery-slash">
      <template slot="text">
        <h1 v-html="$t('label.list_is_empty')"></h1>
        <h4 v-html="$t('label.create_first_item')"></h4>
      </template>
    </nuttrema-empty-result>

    <form-category-questionnaire
       v-else
       slot="central"
      :edit.sync="edit"
      :section="section"
      :CategoriesQuestionnaire="CategoriesQuestionnaire"
      @submit="onFormSubmit">
    </form-category-questionnaire>

    <router-view slot="overflow"></router-view>
  </nuttrema-layout-content>
</template> -->

<script>
import { mapActions } from 'vuex';
import { get } from 'lodash';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import FormCategoryQuestionnaire from './form-category-questionnaire';

export default {
  name: 'page-images-list',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: false,
      default: null,
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
    meta: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaLayoutContent,
    FormCategoryQuestionnaire,
  },
  data() {
    return {
      section: null,
      edit: false,
    };
  },
  computed: {
    ProductDetails() {},
    CategoriesQuestionnaire() {},
    labels() {
      return {
        title: get(this.meta, 'title', false),
        section: get(this.meta, 'section', false),
      };
    },
  },
  watch: {
    id() {
      this.fetchCategoryQuestionnaire();
    },
  },
  methods: {
    ...mapActions({
      SaveCategoryQuestionnaire: '',
    }),
    fetchCategoryQuestionnaire() {},
    clearCategoryQuestionnaire() {},
    onFormSubmit(payload) {
      this.SaveCategoryQuestionnaire({ id: this.id, type: this.type, section: this.section, payload }).then(() => {
        this.successNotification({ label: 'label.categories' });
      }).catch((error) => {
        console.error(error);
        this.errorNotification();
      });
    },
  },
  created() {
    this.fetchCategoryQuestionnaire();
  },
  beforeDestroy() {
    this.clearCategoryQuestionnaire();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/shared/category-questionnaire/page-category-questionnaire.vue